export const RESET_CURRENT_USER = 'RESET_CURRENT_USER'

export const BOOTSTRAP_CURRENT_USER = 'BOOTSTRAP_CURRENT_USER'

export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'

export const UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR'

export const SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE'
